import { createAction } from 'redux-actions';
import {
  DASHBOARD_REQUEST,
  DASHBOARD_SUCCESS,
  DASHBOARD_FAILURE,
  SAVE_NOTES_REQUEST,
  SAVE_NOTES_SUCCESS,
  SAVE_NOTES_FAILURE,
  FETCH_NOTES_REQUEST,
  FETCH_NOTES_SUCCESS,
  FETCH_NOTES_FAILURE,
  RESET_SAVE_NOTES_SUCCESS,

} from './constants';

export const fetchDashboard = createAction(DASHBOARD_REQUEST);
export const dashboardSuccess = createAction(DASHBOARD_SUCCESS);
export const dashboardFailure = createAction(DASHBOARD_FAILURE);

export const saveNotes = createAction(SAVE_NOTES_REQUEST);
export const saveNotesSuccess = createAction(SAVE_NOTES_SUCCESS);
export const saveNotesFailure = createAction(SAVE_NOTES_FAILURE);

export const fetchNotes = createAction(FETCH_NOTES_REQUEST);
export const fetchNotesSuccess = createAction(FETCH_NOTES_SUCCESS);
export const fetchNotesFailure = createAction(FETCH_NOTES_FAILURE);

export const resetSaveNoteSuccess = createAction(RESET_SAVE_NOTES_SUCCESS);
